import { createContext, useContext } from "react";

export const LocaleContext = createContext();

export function useLocale() {
  return useContext(LocaleContext);
}
